import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import { getTag, postAddTag, postUpdateTag } from 'redux/actions/UserTag';
import CommonBreadCrumb from 'components/commonBreadCrumb/CommonBreadCrumb';
import CommonTable from 'components/commonTable/CommonTable';
import AddFeedbackModal from './AddFedbackModal';
import Loader from 'components/loader/Loader';
import { roleAndPermissionEnum } from 'utils/rolesPermissionsEnum';
import { handlePermissions } from 'utils/utils';

function AddFeedbackView() {
  const dispatch = useDispatch();
  const tableData = useSelector((state) => state?.userTag?.userTag?.data);
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(5);
  const [type, setType] = useState('Add');
  const [feedbackData, setFeedbackData] = useState({});
  const loader = useSelector((state) => state?.userTag?.loading);
  useEffect(() => {
    const type = 'Driver';
    dispatch(getTag(type));
  }, []);

  const handleCloseModal = () => {
    setOpen(false);
  };

  const onDialog = (tags) => {
    if (type?.toLowerCase() === 'edit') {
      const val = {
        type: 'Driver',
        starValue: feedbackData?.starValue || value,
        tags: tags?.length > 0 ? tags : feedbackData?.tags,
        id: feedbackData?.id,
      };
      dispatch(postUpdateTag(val));
    } else {
      const val = {
        type: 'Driver',
        starValue: value,
        tags: tags,
      };
      dispatch(postAddTag(val));
    }
    setOpen(false);
  };

  const onChange = (val) => {
    setValue(val);
  };
  const onClickMoreIcon = (data, typeVal) => {
    setFeedbackData(data);
    if (typeVal === 'Delete') {
      const val = {
        id: data.id,
      };
      dispatch(postUpdateTag(val));
    } else if (typeVal === 'Activate') {
      const val = {
        status: 'Active',
        id: data.id,
        type: 'Driver',
      };
      dispatch(postUpdateTag(val));
    } else if (typeVal === 'Deactivate') {
      const val = {
        status: 'InActive',
        id: data.id,
        type: 'Driver',
      };
      dispatch(postUpdateTag(val));
    } else if (typeVal?.toLowerCase() === 'edit') {
      setType('edit');
      setOpen(true);
    }
  };

  const breadcrumbPaths = [
    { name: 'Feedback', url: '', className: 'colorPrimary' },
  ];

  //roles and permissions
  const roleAndPermissions = useSelector(
    (state) => state?.getRolesAndPermissions?.rolesAndPermissions
  );
  const feedbackRoleEnum =
    roleAndPermissionEnum.configuration;

  const accessForall = handlePermissions(
    roleAndPermissions,
    feedbackRoleEnum.moduleKey,
    { defaultAllAccess: feedbackRoleEnum?.subModules?.feedback?.all }
  );

  const accessForEdit = handlePermissions(
    roleAndPermissions,
    feedbackRoleEnum.moduleKey,
    { customAccess: feedbackRoleEnum?.subModules?.feedback?.edit }
  );

  const hasViewMoreIcon = (accessForall || accessForEdit);

  return (
    <div>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        className="marginBlock10"
      >
        <Grid item>
          <CommonBreadCrumb paths={breadcrumbPaths} />
        </Grid>
      </Grid>
      {loader ? (
        <Loader />
      ) : (
        <CommonTable
          data={tableData}
          onClickMoreIcon={onClickMoreIcon}
          tabName={'feedback'}
          isClickable={false}
          viewMoreIcon={!hasViewMoreIcon}
        />
      )}
      <AddFeedbackModal
        open={open}
        handleClose={handleCloseModal}
        onSubmitBtn={onDialog}
        onChange={onChange}
        value={value}
        type={type}
        feedbackData={feedbackData}
      />
    </div>
  );
}

export default AddFeedbackView;
